import React, { useState } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Document, Page, pdfjs } from "react-pdf"
import { HiArrowNarrowRight, HiArrowNarrowLeft } from "react-icons/hi"

import AppInput from "../FormItems/AppInput"

// using ES6 modules
import "react-pdf/dist/esm/Page/AnnotationLayer.css"

// ----------------------------------------------------------------------------

// required by react-pdf/create-react-app integration
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

const PDF_HEIGHT = 200

// ----------------------------------------------------------------------------

function UploadedDocumentPreview(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { doc, onChange, noInput = false } = props

    const docUrl = doc?.url

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [numPages, setNumPages] = useState(null)
    const [pageNumber, setPageNumber] = useState(1)

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleDocValueChange(key) {
        return function (event) {
            onChange && onChange(event.target.value)
        }
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages)
    }

    function handleDocPageChange(newPageNumber) {
        return function (event) {
            event.preventDefault()

            const isValid = newPageNumber > 0 && newPageNumber <= numPages

            isValid && setPageNumber(newPageNumber)
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={props.className}>
            <Document
                className="doc-preview"
                file={docUrl}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={(error) => console.log("PDF ERROR: ", error)}
            >
                <Page height={PDF_HEIGHT} pageNumber={pageNumber} />

                <div className="page-controls">
                    <div
                        className="page-control"
                        onClick={handleDocPageChange(pageNumber - 1)}
                    >
                        <HiArrowNarrowLeft className="arrow-icn" />
                    </div>
                    <div className="page-control">
                        <HiArrowNarrowRight
                            className="arrow-icn"
                            onClick={handleDocPageChange(pageNumber + 1)}
                        />
                    </div>
                </div>
            </Document>

            {!noInput && (
                <AppInput
                    className="name-input"
                    label="Titolo"
                    value={doc.name}
                    onChange={handleDocValueChange("title")}
                />
            )}

            {/* <AppButton onClick={handleDelete} className="remove-btn" uxType="delete">
        Elimina documento
      </AppButton> */}

            {/* <FloatingButton className="delete-btn" onClick={handleDelete}>
				<DeleteOutlined className="delete-icn" />
			</FloatingButton> */}
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

UploadedDocumentPreview.propTypes = {
    className: PropTypes.string.isRequired,
    src: PropTypes.string,
    onDelete: PropTypes.func,
    doc: PropTypes.any,
    onChange: PropTypes.func,
    noInput: PropTypes.bool,
}

UploadedDocumentPreview.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledUploadedDocumentPreview = styled(UploadedDocumentPreview)`
    & {
        position: relative;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        padding: 20px;
        width: 300px;
        height: auto;
        box-sizing: border-box;

        .remove-btn {
            margin-top: 10px;
            min-width: 100%;
            max-width: 100%;
        }

        /* border: 1px solid rgba(0, 0, 0, 0.1);
		border-radius: 8px;

		background-color: rgba(0, 0, 0, 0.1); */

        .doc-preview {
            position: relative;
            margin-bottom: 10px;

            min-height: ${PDF_HEIGHT}px;
            max-height: ${PDF_HEIGHT}px;
            max-width: 80%;

            border-radius: 8px;

            canvas {
                border-radius: 4px;
                box-shadow: ${(props) => props?.theme?.shadows?.cardBoxShadow};
            }

            :hover {
                .page-controls {
                    opacity: 1;
                }
            }

            .page-controls {
                position: absolute;
                bottom: 15px;
                left: 50%;
                transform: translateX(-50%);

                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;

                height: 30px;
                width: 70px;

                opacity: 0;

                .page-control {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;

                    height: 30px;
                    width: 30px;
                    border-radius: 50%;

                    background-color: rgba(0, 0, 0, 0.5);
                    backdrop-filter: blur(10px);

                    cursor: pointer;

                    transition: all 0.2s ease-in-out;

                    .arrow-icn {
                        font-size: 20px;
                        color: #fff;
                    }

                    :hover {
                        background-color: rgba(0, 0, 0, 0.6);
                    }
                }
            }
        }

        .name-input {
            margin-top: 10px;
        }

        .desc-input {
            margin-top: 10px;
            max-height: 100px;
        }

        .delete-btn {
            position: absolute;
            top: 0;
            right: 0;

            transform: translate(50%, -50%);

            transition: all 0.2s ease-in-out;

            opacity: 0;

            .delete-icn {
                font-size: 20px;
                color: ${(props) => props?.theme?.colors?.textPrimary};
            }
        }

        :hover {
            .delete-btn {
                opacity: 1;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledUploadedDocumentPreview
